// © Microsoft Corporation. All rights reserved.

export enum CookieConsentProvider {
    /**
     * Consent status is provided by the MSCC banner.
     */
    MSCCBanner = "mscc",
    /**
     * Consent status is provided by the OneTrust banner.
     */
    OneTrustBanner = "onetrust",
    /**
     * Consent status is provided by the Widget host page.
     */
    WidgetHost = "widgethost",
    /**
     * Consent status is not provided by anyone since it's not required.
     */
    None = "none"
}
